import axios, { AxiosInstance }                       from 'axios';
import { getFeatureVersion, getHotelUuid, getPoImplementationVersion } from '@/helpers/variables';

export const client: AxiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API_CLIENT}/hotels/${getHotelUuid()}`,
  headers: { 'Feature-Flag-Version': getFeatureVersion() },
});

export const priceOptimizerClient: AxiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API_CLIENT}/hotels/${getHotelUuid()}`,
  headers: { 'Po-Implementation-Version': getPoImplementationVersion(), 'Feature-Flag-Version': getFeatureVersion() },
});
